<script lang="ts" setup>
import { useI18n } from '@/plugins/i18n'

// emits
const emit = defineEmits(['handleDocAction', 'handleSelectItem']);

//props
interface Props {
  searchTerms?: string,
  searchTips: string[]
}
const props = withDefaults(defineProps<Props>(), {
  item: {},
  searchTerms: '',
  searchTips: () => [],
})

//translations
const i18nInstance: any = useI18n()
const { t } = i18nInstance

</script>

<template>
    <div class="no-results-pane">
        <div v-if="searchTerms!=''" class="no-result-msg">{{  t('noResultFoundFor') }} "<strong> {{ props.searchTerms }}</strong>".</div>
        <div v-else class="no-result-msg">{{ t('no_result_found') }}</div>
        <div class="no-result-img"><img src="@/assets/img/search-noresult.svg"/></div>
        <div class="search-tips">
            <label>{{ t('searchTips') }}</label>
            <ul class="search-tips-points">
                <li v-for="tip in searchTips" :key="tip">
                    {{ t(tip) }}
                </li>
            </ul>
        </div>
    </div>
</template>
<style lang="scss">
    @use './style.scss';
</style>